import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormCategory from './Form/FormCategory'

function NewCategory({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerCategory(category) {
        let msgType = 'success'

        const data = await api.post('/category/new', category, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormCategory title="Cadastrar Categoria" handleSubmit={registerCategory} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewCategory
